export class Cell {
  cellName: string | any;
}
